import FlexPane from './_flex-pane.js'
import EventTimingStatus from './_event-timing-status.js'
import Text from './_text.js'
import BaseEventCard from './_base-event-card.js'
import SelectionButton from './_selection-button.js'
import SportIcons from './_sport-icons.js'
import Image from './_image.js'
import AbsolutePane from './_absolute-pane.js'

export default {
  name: 'SelectionCard',
  values: {
    showSportIcon: true,
    showBackgroundSportImage: true,
    noBackgroundImageSports: [
    ],
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          padding: '0 8px',
          justifyContent: 'space-between',
          flexGrow: 0,
          height: '30px',
        },
      },
    },
    headerTime: {
      configSet: EventTimingStatus,
      configValues: {
        container: {
          style: {
            base: {
              alignSelf: 'start',
              flexDirection: 'row-reverse',
              whiteSpace: 'nowrap',
            },
          },
        },
      },
    },
    headerLiveLabel: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'right',
        },
      },
    },
    genericEventCard: {
      configSet: BaseEventCard,
      configValues: {
        title: {
          truncate: true,
          ellipsisOnLineNumber: 2,
        },
        container: {
          createStackingContext: true,
          style: {
            padding: '8px 0 0',
            overflow: 'hidden',
          },
        },
        clickableArea: {
          style: {
            base: {
              justifyContent: 'start',
            },
          },
        },
      },
    },
    boostedEventCard: {
      configSet: BaseEventCard,
      configValues: {
        title: {
          truncate: true,
          ellipsisOnLineNumber: 2,
        },
        container: {
          createStackingContext: true,
          style: {
            padding: '8px 0 0',
            overflow: 'hidden',
          },
        },
        clickableArea: {
          style: {
            base: {
              justifyContent: 'start',
            },
          },
        },
      },
    },
    selectionInfo: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          padding: '0 8px',
          flexDirection: 'column',
        },
      },
    },
    selectionName: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 2,
        container: {
          flexGrow: 0,
        },
      },
    },
    marketName: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 2,
        container: {
          flexGrow: 0,
        },
      },
    },
    priceBoostContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          flexGrow: 0,
        },
      },
    },
    selection: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          justifyContent: 'flex-end',
          flexGrow: 0,
        },
      },
    },
    selectionButton: {
      configSet: SelectionButton,
      configValues: {
        view: {
          width: '80px',
          height: '40px',
          handicapDisplay: false,
          nameDisplay: 'hide',
          _mobile_nameDisplay: 'hide',
        },
      },
    },
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
    sportIcon: {
      configSet: Image,
      configValues: {
        style: {
          flexGrow: 0,
          width: '12px',
          height: '16px',
        },
      },
    },
    boostedBackgroundImageContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '106px',
          height: '91px',
          top: '8px',
          right: '8px',
          overflow: 'hidden',
        },
      },
    },
    boostedBackgroundSportImage: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '120px',
          minHeight: '120px',
          alignSelf: 'flex-end',
          padding: '0 0 8px 8px',
        },
      },
    },
    genericBackgroundImageContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '106px',
          height: '91px',
          bottom: '8px',
          left: '8px',
          overflow: 'hidden',
        },
      },
    },
    genericBackgroundSportImage: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '120px',
          minHeight: '120px',
          alignSelf: 'flex-start',
          padding: '0 22px 0 0',
        },
      },
    },
    priceBoostTitleAndImageContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '6px',
        style: {
          padding: '8px',
          alignItems: 'center',
          flexGrow: 0,
        },
      },
    },
    priceBoostTitle: {
      configSet: Text,
      configValues: {},
    },
    priceBoostImageContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    priceBoostImage: {
      configSet: Image,
      configValues: {
        src: 'lightning',
        style: {
          minWidth: '18px',
          minHeight: '18px',
        },
      },
    },
    basePriceContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'flex-end',
        },
      },
    },
    basePriceInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          alignItems: 'center',
          flexDirection: 'column',
          flexGrow: 0,
        },
      },
    },
    basePriceTitle: {
      configSet: Text,
      configValues: {},
    },
    basePriceAmount: {
      configSet: Text,
      configValues: {
        style: {
          textDecoration: 'line-through',
        },
      },
    },
    basePriceImage: {
      configSet: Image,
      configValues: {
        src: 'double-arrow-right',
        style: {
          minWidth: '12px',
          minHeight: '12px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
